import { useState } from "react";
import type { CalculatorType } from "web_myplann/Calculators/Types/CalculatorType";

export const useCalculatorUnavailableDrawer = () => {
	const [unavailableType, setUnavailableType] = useState<CalculatorType>();
	const [isUnavailableOpen, setIsUnavailableOpen] = useState(false);

	const openUnavailable = (type: CalculatorType) => {
		setUnavailableType(type);
		setIsUnavailableOpen(true);
	};

	const closeUnavailable = () => setIsUnavailableOpen(false);

	return {
		unavailableType,
		isUnavailableOpen,
		openUnavailable,
		closeUnavailable,
	};
};
